import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import ComingSoon from "./comingsoon";


const App = () => {
  return (
    <Router>
      <Routes>
        {/* <Route path="/*" element={<ComingSoon/>} /> */}
        <Route path="/*" element={<ComingSoon/>} />
      </Routes>
    </Router>
  );
};

export default App;
